import React, { useRef } from "react";

import { Button, Icon } from "@culturehq/components";
import { Organization } from "chq";
import { Trans } from "app/utils";
import { useIsLoggedIn, useIsMobile } from "app/hooks";
import { usePostStoryContext } from "components/stories/post-stories-v2/contexts/PostStoryContext";
import CameraRecorder from "components/common/CameraRecorder";

type PostStoryMediaButtonsProps = {
  magicScriptText?: string;
  onNextStep: () => void;
};

const PostStoryMediaButtons: React.FC<PostStoryMediaButtonsProps> = ({
  magicScriptText, onNextStep
}) => {
  const isLoggedIn = useIsLoggedIn();
  const isMobile = useIsMobile();

  const {
    setState: setPostStoryState,
    organization,
    handleFilesSelected,
    handleMediaChange
  } = usePostStoryContext();
  const fileInputRef = useRef<HTMLInputElement>(null);

  const actionName = isLoggedIn ? "Upload" : "Add";

  const handleSelectedFile = (event: React.ChangeEvent<HTMLInputElement>) => {
    handleFilesSelected(event);
    if (isMobile) onNextStep();
  };

  const handleOpenCameraRecorder = () => setPostStoryState({ pausedVideo: true });

  return (
    <div className="MediaButtons">
      <div className="MediaButtons__Container">
        <Button
          className="MediaButtons__AddMedia-btn"
          style={isMobile ? { flex: "auto" } : {}}
          onClick={() => fileInputRef.current?.click()}
          onKeyDown={(e: { key: string }) => {
            if (e.key === "Enter" && fileInputRef.current) fileInputRef.current.click();
          }}
        >
          {isMobile ? (
            <>
              <Icon icon="video-camera-filled-complete" />{" "}
              <Trans>Add Video</Trans>
            </>
          ) : (
            <>
              <Icon icon="upload-video" />{" "}
              <Trans>{actionName}{" "}video</Trans>
            </>
          )}
          <input
            ref={fileInputRef}
            accept="video/*"
            type="file"
            style={{ display: "none" }}
            onChange={handleSelectedFile}
          />
        </Button>
        <CameraRecorder
          organization={organization as Organization}
          className="MediaButtons__AddRecord-btn"
          onVideoRecorded={handleMediaChange}
          script={magicScriptText}
          onOpen={handleOpenCameraRecorder}
        >
          <Icon icon="video-camera-filled" />
          <Trans>Record video</Trans>
        </CameraRecorder>
      </div>
    </div>
  );
};

export default PostStoryMediaButtons;
